import { render, staticRenderFns } from "./checkDeskShow.vue?vue&type=template&id=7408355c&scoped=true&"
import script from "./checkDeskShow.vue?vue&type=script&lang=js&"
export * from "./checkDeskShow.vue?vue&type=script&lang=js&"
import style0 from "./checkDeskShow.vue?vue&type=style&index=0&id=7408355c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7408355c",
  null
  
)

export default component.exports